<div class="price-input">
    <span>{{ currencySymbol }}</span>
    <input
        type="text"
        class="primary"
        id="{{ id }}"
        autocomplete="{{ autoComplete }}"
        (keypress)="onKeyPress($event)"
        (input)="onInput($event)"
        [value]="stringValue"
        [required]="required"
        [disabled]="disabled"
        (blur)="onBlur()"
    />
</div>
